import type { ClassValue } from 'clsx'

export function cn(...inputs: ClassValue[]) {
  return typeof require('clsx') === 'function'
    ? require('clsx')(inputs)
    : inputs.filter(Boolean).join(' ')
}
